export default "__VITE_ASSET__D84w0aSR__"